export const sportCategories = [
  {
    id: 'football',
    name: '足球',
    icon: 'ri-football-line',
    description: '全球最受欢迎的体育项目，涵盖英超、西甲、欧冠等顶级赛事',
    eventCount: 128,
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20soccer%20football%20stadium%20atmosphere%20with%20dramatic%20lighting%2C%20green%20pitch%20under%20floodlights%2C%20professional%20sports%20photography%20style%2C%20energetic%20and%20powerful%20composition%2C%20dark%20background%20with%20warm%20golden%20accents%2C%20sporting%20event%20ambiance%2C%20no%20visible%20text%20or%20logos&width=800&height=600&seq=cat-football-01&orientation=landscape',
  },
  {
    id: 'basketball',
    name: '篮球',
    icon: 'ri-basketball-line',
    description: 'NBA、CBA等顶级篮球联赛全覆盖，实时比分与赔率同步更新',
    eventCount: 96,
    image: 'https://readdy.ai/api/search-image?query=Intense%20basketball%20game%20action%20on%20professional%20court%20with%20dramatic%20arena%20lighting%2C%20orange%20ball%20in%20motion%2C%20athletic%20energy%2C%20dark%20stadium%20background%20with%20spotlights%2C%20sports%20photography%20aesthetic%2C%20powerful%20dynamic%20composition&width=800&height=600&seq=cat-basketball-01&orientation=landscape',
  },
  {
    id: 'tennis',
    name: '网球',
    icon: 'ri-medal-line',
    description: '四大满贯赛事及ATP/WTA巡回赛，精彩对决不容错过',
    eventCount: 74,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20tennis%20court%20with%20player%20in%20action%20during%20golden%20hour%2C%20clay%20court%20surface%20with%20dramatic%20shadows%2C%20professional%20sports%20photography%2C%20warm%20evening%20light%2C%20clean%20minimalist%20background%2C%20athletic%20grace%20and%20power%2C%20no%20visible%20branding&width=800&height=600&seq=cat-tennis-01&orientation=landscape',
  },
  {
    id: 'esports',
    name: '电竞',
    icon: 'ri-gamepad-line',
    description: 'LOL、DOTA2、CS2等热门电竞赛事，覆盖全球各大联赛',
    eventCount: 112,
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20esports%20arena%20with%20vibrant%20neon%20lighting%20and%20massive%20LED%20screens%2C%20gaming%20tournament%20atmosphere%2C%20dark%20ambient%20background%20with%20colorful%20light%20streaks%2C%20professional%20gaming%20stage%2C%20energetic%20crowd%20silhouettes%2C%20cyberpunk%20aesthetic&width=800&height=600&seq=cat-esports-01&orientation=landscape',
  },
  {
    id: 'table-tennis',
    name: '乒乓球',
    icon: 'ri-base-station-line',
    description: '国际乒联世界巡回赛及各大公开赛，国球荣耀尽在其中',
    eventCount: 45,
    image: 'https://readdy.ai/api/search-image?query=Professional%20table%20tennis%20match%20with%20fast%20action%20closeup%2C%20white%20ball%20in%20motion%20on%20blue%20table%2C%20dramatic%20sports%20lighting%2C%20dark%20background%20with%20arena%20atmosphere%2C%20intense%20competition%20moment%2C%20clean%20professional%20photography%20style&width=800&height=600&seq=cat-pingpong-01&orientation=landscape',
  },
  {
    id: 'baseball',
    name: '棒球',
    icon: 'ri-football-line',
    description: 'MLB美国职棒大联盟及日职棒赛事，精彩本垒打时刻',
    eventCount: 38,
    image: 'https://readdy.ai/api/search-image?query=Professional%20baseball%20game%20in%20large%20stadium%20at%20sunset%2C%20batter%20swinging%20with%20dramatic%20motion%2C%20green%20field%20under%20golden%20sky%2C%20sports%20photography%20aesthetic%2C%20warm%20atmospheric%20lighting%2C%20clean%20composition%20without%20visible%20branding&width=800&height=600&seq=cat-baseball-01&orientation=landscape',
  },
];

export const featuredEvents = [
  {
    id: 1,
    category: '足球',
    league: '英超联赛',
    homeTeam: '曼城',
    awayTeam: '阿森纳',
    homeOdds: 1.85,
    drawOdds: 3.60,
    awayOdds: 4.20,
    time: '2026-08-10 03:00',
    status: 'upcoming',
    popular: true,
  },
  {
    id: 2,
    category: '足球',
    league: '西甲联赛',
    homeTeam: '皇家马德里',
    awayTeam: '巴塞罗那',
    homeOdds: 2.10,
    drawOdds: 3.40,
    awayOdds: 3.50,
    time: '2026-08-12 04:00',
    status: 'upcoming',
    popular: true,
  },
  {
    id: 3,
    category: '篮球',
    league: 'NBA',
    homeTeam: '洛杉矶湖人',
    awayTeam: '金州勇士',
    homeOdds: 1.65,
    drawOdds: 0,
    awayOdds: 2.30,
    time: '2026-08-09 10:30',
    status: 'live',
    popular: true,
  },
  {
    id: 4,
    category: '篮球',
    league: 'NBA',
    homeTeam: '波士顿凯尔特人',
    awayTeam: '密尔沃基雄鹿',
    homeOdds: 1.90,
    drawOdds: 0,
    awayOdds: 1.95,
    time: '2026-08-11 08:00',
    status: 'upcoming',
    popular: false,
  },
  {
    id: 5,
    category: '网球',
    league: '温布尔登网球锦标赛',
    homeTeam: '阿尔卡拉斯',
    awayTeam: '辛纳',
    homeOdds: 1.72,
    drawOdds: 0,
    awayOdds: 2.15,
    time: '2026-08-09 20:00',
    status: 'live',
    popular: true,
  },
  {
    id: 6,
    category: '电竞',
    league: 'LPL夏季赛',
    homeTeam: 'JDG',
    awayTeam: 'BLG',
    homeOdds: 1.55,
    drawOdds: 0,
    awayOdds: 2.50,
    time: '2026-08-10 17:00',
    status: 'upcoming',
    popular: true,
  },
  {
    id: 7,
    category: '足球',
    league: '欧冠联赛',
    homeTeam: '拜仁慕尼黑',
    awayTeam: '巴黎圣日耳曼',
    homeOdds: 1.95,
    drawOdds: 3.80,
    awayOdds: 3.40,
    time: '2026-08-13 03:00',
    status: 'upcoming',
    popular: false,
  },
  {
    id: 8,
    category: '电竞',
    league: 'DOTA2国际邀请赛',
    homeTeam: 'Team Spirit',
    awayTeam: 'OG',
    homeOdds: 2.00,
    drawOdds: 0,
    awayOdds: 1.85,
    time: '2026-08-09 15:00',
    status: 'live',
    popular: false,
  },
];

export const latestNews = [
  {
    id: 1,
    title: '2026赛季英超联赛前瞻：争冠格局全面解析',
    excerpt: '新赛季英超即将拉开帷幕，曼城、阿森纳、利物浦等豪门蓄势待发。本文为您全面解析新赛季争冠格局与关键看点。',
    category: '足球',
    date: '2026-08-07',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=English%20Premier%20League%20stadium%20panoramic%20view%20with%20dramatic%20sunset%20sky%2C%20green%20pitch%20and%20empty%20seats%20creating%20anticipation%2C%20professional%20sports%20photography%2C%20warm%20golden%20hour%20lighting%2C%20atmospheric%20and%20majestic%20composition&width=800&height=500&seq=news-premier-01&orientation=landscape',
  },
  {
    id: 2,
    title: 'NBA新赛季交易汇总：巨星动向全知道',
    excerpt: '休赛期交易市场风起云涌，多位全明星球员改换门庭。深度分析各队阵容变化对新赛季格局的影响。',
    category: '篮球',
    date: '2026-08-06',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=NBA%20basketball%20arena%20with%20dramatic%20spotlight%20on%20center%20court%2C%20professional%20sports%20venue%20atmosphere%2C%20dark%20ambient%20background%20with%20golden%20court%20lighting%2C%20anticipation%20before%20big%20game%2C%20clean%20composition&width=800&height=500&seq=news-nba-01&orientation=landscape',
  },
  {
    id: 3,
    title: '电竞产业2026：市场规模突破新高度',
    excerpt: '全球电竞产业持续高速增长，2026年市场规模预计突破200亿美元。深度解读电竞行业发展新趋势。',
    category: '电竞',
    date: '2026-08-05',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20esports%20gaming%20arena%20with%20holographic%20displays%20and%20neon%20ambient%20lighting%2C%20professional%20gaming%20tournament%20stage%2C%20dark%20atmosphere%20with%20vibrant%20cyan%20and%20gold%20accents%2C%20modern%20technology%20aesthetic&width=800&height=500&seq=news-esports-01&orientation=landscape',
  },
  {
    id: 4,
    title: '温网经典回顾：传奇对决永载史册',
    excerpt: '回顾温布尔登历史上最令人难忘的经典对决，从费德勒到德约科维奇，草地之王传承永不停歇。',
    category: '网球',
    date: '2026-08-04',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Wimbledon%20tennis%20grass%20court%20with%20golden%20sunset%20lighting%20and%20historic%20clubhouse%20background%2C%20elegant%20sports%20venue%20atmosphere%2C%20traditional%20English%20sporting%20aesthetic%2C%20warm%20golden%20hour%20photography&width=800&height=500&seq=news-wimbledon-01&orientation=landscape',
  },
  {
    id: 5,
    title: '开云体育平台安全升级：多重加密保障用户数据',
    excerpt: '开云体育在线全面升级安全系统，采用银行级SSL加密技术，确保每位用户的账户信息与资金安全万无一失。',
    category: '平台动态',
    date: '2026-08-03',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20cybersecurity%20concept%20with%20abstract%20digital%20shield%20and%20data%20protection%20visualization%2C%20dark%20blue%20and%20gold%20color%20scheme%2C%20professional%20technology%20aesthetic%2C%20clean%20minimalist%20design%2C%20trustworthy%20and%20secure%20atmosphere&width=800&height=500&seq=news-security-01&orientation=landscape',
  },
  {
    id: 6,
    title: '乒乓球世锦赛：中国队再创辉煌战绩',
    excerpt: '2026年世界乒乓球锦标赛落下帷幕，中国队包揽全部五项冠军，展现强大统治力。详细赛事回顾与分析。',
    category: '乒乓球',
    date: '2026-08-02',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Professional%20table%20tennis%20competition%20moment%20with%20dramatic%20lighting%20on%20blue%20table%2C%20fast%20action%20and%20athletic%20intensity%2C%20large%20arena%20background%20with%20spectators%2C%20sports%20photography%20style%2C%20Olympic%20level%20atmosphere&width=800&height=500&seq=news-pingpong-01&orientation=landscape',
  },
];

export const faqData = [
  {
    id: 1,
    question: '开云体育在线平台是否合法合规？',
    answer: '开云体育在线持有国际合法运营牌照，严格遵守所在地法律法规，致力于为全球用户提供安全、公平、透明的体育娱乐服务。所有运营资质均可在官网查看验证。',
  },
  {
    id: 2,
    question: '如何注册开云体育在线账号？',
    answer: '注册流程非常简单：点击官网右上角"注册"按钮，填写手机号或邮箱地址，设置登录密码，完成手机或邮箱验证即可。新用户注册即享专属欢迎礼包，包含首存优惠和免费投注金。',
  },
  {
    id: 3,
    question: '平台支持哪些存取款方式？',
    answer: '开云体育在线支持多种安全便捷的存取款方式，包括：银行卡转账、USDT虚拟货币、微信支付、支付宝等多种主流支付渠道。存款即时到账，提款最快5分钟到账，资金安全有保障。',
  },
  {
    id: 4,
    question: '平台提供哪些体育赛事投注？',
    answer: '平台覆盖全球超过30种体育项目，包括足球、篮球、网球、电竞、乒乓球、棒球、冰球、橄榄球等。提供赛前投注和滚球投注两种模式，赔率更新实时同步，让您不错过任何精彩赛事。',
  },
  {
    id: 5,
    question: '如何联系开云体育在线客服？',
    answer: '我们提供7×24小时在线客服服务，您可以通过官网在线客服窗口、官方客服邮箱或官方APP联系我们的客服团队。专业客服人员将在3分钟内响应您的需求，解决您遇到的所有问题。',
  },
  {
    id: 6,
    question: '平台有哪些优惠活动？',
    answer: '开云体育在线持续推出丰富的优惠活动：新用户注册礼包、首存100%红利、每日签到奖励、赛事竞猜返水、VIP会员专属福利等。具体活动详情请关注平台公告和优惠中心页面。',
  },
];

export const platformFeatures = [
  { icon: 'ri-shield-check-line', title: '安全可靠', description: '银行级加密技术，资金安全有保障' },
  { icon: 'ri-flashlight-line', title: '极速提款', description: '提款最快5分钟到账，高效便捷' },
  { icon: 'ri-global-line', title: '全球赛事', description: '覆盖30+体育项目，赛事丰富全面' },
  { icon: 'ri-customer-service-2-line', title: '7×24客服', description: '全天候在线客服，3分钟响应' },
];

export const statsData = [
  { value: '500万+', label: '注册用户' },
  { value: '30+', label: '体育项目' },
  { value: '99.9%', label: '资金安全率' },
  { value: '5分钟', label: '最快提款' },
];